module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"pt-BR":{"btn-create":"Criar pedido"},"en-US":{"btn-create":"Create order"}}')
  delete Component.options._Ctor
}
